import React from 'react';
import { Pagination as MuiPagination, Stack } from '@mui/material';

const Pagination = ({ count, page, onPageChange }) => {
    return (
        <Stack spacing={2} direction="row" justifyContent="center">
            <MuiPagination
                count={count}
                page={page}
                onChange={onPageChange}
                color="primary"
                shape="rounded"
                showFirstButton
                showLastButton
            />
        </Stack>
    );
};

export default Pagination;
